export const translation = {
  "nav.home": "Accueil",
  "nav.spreadsheet": "Tableur",
  "nav.guides": "Guides",
  "nav.shipping": "Expédition",
  "nav.qc": "Contrôle Qualité",
  "nav.reviews": "Avis",
  "nav.comparisons": "Comparaisons",
  "nav.safety": "Sécurité",
  "nav.categories": "Catégories",
  "nav.language": "Langue",
  "nav.about": "À Propos",
  "nav.contact": "Contact",
  "nav.buyingGuide": "Guide d'Achat",
  "nav.faq": "FAQ",
  "hero.title": "AllChinaBuy Spreadsheet — Votre Guide Complet pour les Produits, Vendeurs, Contrôle Qualité & Expédition",
  "hero.subtitle": "Trouvez de Meilleurs Produits avec le Tableur AllChinaBuy",
  "hero.description": "Le AllChinaBuy Spreadsheet est un point de départ pratique pour découvrir des produits, rechercher des vendeurs et comprendre le processus d'achat. Explorez des listes de produits, des informations sur les vendeurs, des ressources de contrôle qualité, des guides d'expédition et des conseils utiles dans une ressource organisée.",
  "hero.cta.primary": "Explorer le Tableur AllChinaBuy",
  "hero.cta.secondary": "Parcourir le Guide Complet",
  "hero.trust": "Ressource Indépendante • Guides Actualisés • Informations d'Achat Pratiques",
  "cta.mainWebsite": "AllChinaBuy Spreadsheet",
  "cta.buyNow": "Acheter Maintenant",
  "cta.visitMain": "Visiter le Site Principal",
  "section.whatIs.title": "Qu'est-ce que le AllChinaBuy Spreadsheet ?",
  "section.whatIs.description": "Vous cherchez un moyen plus simple de rechercher des produits et des vendeurs ? Le AllChinaBuy Spreadsheet rassemble des informations utiles sur les produits dans une ressource consultable. Au lieu de passer d'un lien à l'autre, utilisez le tableur pour découvrir des catégories, comparer des options et poursuivre vos recherches avec des guides détaillés.",
  "section.whatIs.cta": "Explorer les Ressources du Tableur",
  "section.everything.title": "Tout ce que Vous Devez Savoir sur AllChinaBuy",
  "card.spreadsheet.title": "AllChinaBuy Spreadsheet",
  "card.spreadsheet.desc": "Découvrez des produits, des catégories et des ressources vendeurs.",
  "card.review.title": "Avis AllChinaBuy",
  "card.review.desc": "Comprenez la plateforme, les fonctionnalités, le processus d'achat et les considérations importantes.",
  "card.shipping.title": "Coût d'Expédition AllChinaBuy",
  "card.shipping.desc": "Apprenez les méthodes d'expédition, les facteurs de prix, les délais de livraison et les moyens de réduire les coûts.",
  "card.warehouse.title": "Entrepôt AllChinaBuy",
  "card.warehouse.desc": "Comprenez le stockage, les photos de contrôle qualité, la préparation des colis et le workflow d'expédition.",
  "card.coupon.title": "Coupon AllChinaBuy",
  "card.coupon.desc": "Trouvez les informations de coupon actuelles et comprenez comment les remises fonctionnent.",
  "card.discount.title": "Code de Réduction AllChinaBuy",
  "card.discount.desc": "Explorez les informations de réduction disponibles et vérifiez les conditions avant d'utiliser un code.",
  "card.legit.title": "AllChinaBuy Est-il Légitime ?",
  "card.legit.desc": "Apprenez à évaluer la légitimité de la plateforme, la fiabilité des vendeurs et les risques d'achat courants.",
  "card.qc.title": "Contrôle Qualité AllChinaBuy",
  "card.qc.desc": "Comprenez les photos de contrôle qualité, les vérifications de produits et ce qu'il faut examiner avant l'expédition.",
  "card.shippingCost.title": "Coût d'Expédition AllChinaBuy",
  "card.shippingCost.desc": "Comprenez les tarifs d'expédition, les méthodes, les facteurs de poids et comment estimer les coûts.",
  "card.discountCode.title": "Code de Réduction AllChinaBuy",
  "card.discountCode.desc": "Trouvez les codes de réduction actuels et apprenez à vérifier les offres avant utilisation.",
  "card.sellers.title": "Vendeurs AllChinaBuy",
  "card.sellers.desc": "Apprenez à identifier les vendeurs de confiance et à éviter les vendeurs peu fiables.",
  "card.comparison.title": "Comparaison AllChinaBuy",
  "card.comparison.desc": "Comparez AllChinaBuy avec d'autres agents sur les dimensions clés.",
  "card.buyingGuide.title": "Guide d'Achat AllChinaBuy",
  "card.buyingGuide.desc": "Un guide étape par étape de la recherche de produits à la livraison finale.",
  "card.beginner.title": "AllChinaBuy pour Débutants",
  "card.beginner.desc": "Tout ce que les nouveaux acheteurs doivent savoir avant leur première commande.",
  "card.payment.title": "Guide de Paiement AllChinaBuy",
  "card.payment.desc": "Comprenez les méthodes de paiement, les étapes et les bonnes pratiques de sécurité.",
  "card.refund.title": "Guide de Remboursement AllChinaBuy",
  "card.refund.desc": "Découvrez comment fonctionnent les retours, litiges et remboursements.",
  "card.parcel.title": "Guide de Colis AllChinaBuy",
  "card.parcel.desc": "Conseils d'emballage, de consolidation et de protection pour l'expédition internationale.",
  "card.safetyGuide.title": "Guide de Sécurité AllChinaBuy",
  "card.safetyGuide.desc": "Évitez les arnaques, protégez votre compte et achetez en toute confiance.",
  "section.howTo.title": "Comment Utiliser le AllChinaBuy Spreadsheet",
  "step1": "Choisissez une catégorie de produits.",
  "step2": "Ouvrez la ressource du tableur correspondante.",
  "step3": "Comparez les produits et les vendeurs.",
  "step4": "Examinez les informations de contrôle qualité et les détails du vendeur.",
  "step5": "Vérifiez les informations d'expédition avant de commander.",
  "step6": "Continuez vers le site principal lorsque vous êtes prêt.",
  "section.categories.title": "Catégories Populaires du AllChinaBuy Spreadsheet",
  "category.shoes": "Chaussures",
  "category.hoodies": "Sweats à Capuche/Pulls",
  "category.tshirts": "T-Shirts",
  "category.jackets": "Vestes",
  "category.pants": "Pantalons/Shorts",
  "category.headwear": "Couvre-Chefs",
  "category.sets": "Ensembles",
  "category.underwear": "Sous-Vêtements/Caleçons",
  "category.jersey": "Maillots",
  "category.accessories": "Accessoires",
  "category.bags": "Sacs",
  "category.belts": "Ceintures",
  "category.perfumes": "Parfums",
  "category.other": "Autres Articles",
  "section.compare.title": "Comparez Avant d'Acheter",
  "section.shipping.title": "Guide d'Expédition AllChinaBuy",
  "section.shipping.description": "Les coûts d'expédition peuvent varier en fonction du poids du colis, de la destination, de la méthode d'expédition, des dimensions et des conditions actuelles des transporteurs. Utilisez nos ressources d'expédition pour comprendre les principaux facteurs de coût avant de préparer un colis.",
  "section.shipping.cta": "Voir le Guide des Coûts d'Expédition",
  "section.safety.title": "Guide de Sécurité AllChinaBuy",
  "section.safety.description": "L'achat via des marchés internationaux nécessite une recherche approfondie. Apprenez à vérifier les vendeurs, examiner les informations de contrôle qualité, protéger les détails de votre compte, comprendre les risques d'expédition et reconnaître les offres suspectes.",
  "section.safety.cta": "Lire le Guide de Sécurité AllChinaBuy",
  "section.guides.title": "Derniers Guides AllChinaBuy",
  "section.faq.title": "Questions Fréquemment Posées",
  "faq.q1": "Qu'est-ce que le AllChinaBuy Spreadsheet ?",
  "faq.a1": "Le AllChinaBuy Spreadsheet est une ressource organisée qui compile des informations sur les produits, les détails des vendeurs et des guides d'achat pour vous aider à rechercher des produits plus efficacement.",
  "faq.q2": "Comment fonctionne le AllChinaBuy Spreadsheet ?",
  "faq.a2": "Le tableur classe les produits par type, vous permettant de parcourir les catégories, comparer les options et trouver les vendeurs pertinents avec des informations détaillées.",
  "faq.q3": "AllChinaBuy est-il légitime ?",
  "faq.a3": "AllChinaBuy est une plateforme d'agent d'achat. Comme tout marché international, il est important de rechercher les vendeurs, examiner les photos de contrôle qualité et comprendre le processus avant d'acheter.",
  "faq.q4": "AllChinaBuy est-il sûr ?",
  "faq.a4": "La sécurité dépend du respect des meilleures pratiques : vérifiez les vendeurs, examinez les photos de contrôle qualité, utilisez des méthodes de paiement sécurisées et comprenez les politiques d'expédition et de remboursement.",
  "faq.q5": "Combien coûte l'expédition AllChinaBuy ?",
  "faq.a5": "Les coûts d'expédition varient en fonction du poids, des dimensions, de la destination, de la méthode d'expédition et des tarifs actuels des transporteurs. Utilisez notre guide d'expédition pour des informations détaillées.",
  "faq.q6": "Où se trouve l'entrepôt AllChinaBuy ?",
  "faq.a6": "AllChinaBuy exploite des entrepôts en Chine pour recevoir, inspecter et expédier des colis aux acheteurs internationaux.",
  "faq.q7": "Comment fonctionnent les coupons AllChinaBuy ?",
  "faq.a7": "Les coupons et codes de réduction peuvent être disponibles pour les nouveaux utilisateurs, les promotions saisonnières ou des catégories de produits spécifiques. Vérifiez toujours les conditions et les dates d'expiration.",
  "faq.q8": "Où puis-je trouver un code de réduction AllChinaBuy ?",
  "faq.a8": "Les codes de réduction peuvent être disponibles via des e-mails promotionnels, des partenaires affiliés ou des campagnes saisonnières. Consultez notre guide de coupons pour les informations actuelles.",
  "faq.q9": "Comment vérifier les photos de contrôle qualité ?",
  "faq.a9": "Les photos de contrôle qualité sont prises à l'entrepôt avant l'expédition. Vous pouvez les consulter dans votre compte pour vérifier l'état, la couleur et les détails du produit.",
  "faq.q10": "Comment puis-je trouver des produits via AllChinaBuy ?",
  "faq.a10": "Utilisez le tableur pour parcourir les catégories, ou recherchez directement par nom de produit, catégorie ou vendeur pour trouver ce que vous cherchez.",
  "finalCta.title": "Prêt à Explorer le AllChinaBuy Spreadsheet ?",
  "finalCta.description": "Commencez par le tableur, comparez vos options, apprenez comment fonctionne le processus d'achat et utilisez nos guides pour prendre des décisions plus éclairées.",
  "finalCta.button": "Explorer le AllChinaBuy Spreadsheet",
  "footer.spreadsheet": "AllChinaBuy Spreadsheet",
  "footer.guides": "Guides",
  "footer.reviews": "Avis",
  "footer.shipping": "Expédition",
  "footer.qc": "Contrôle Qualité",
  "footer.safety": "Sécurité",
  "footer.about": "À Propos",
  "footer.contact": "Contact",
  "footer.privacy": "Politique de Confidentialité",
  "footer.terms": "Conditions Générales",
  "footer.disclaimer": "Clause de Non-Responsabilité",
  "footer.disclaimerText": "Ce site est une ressource d'information indépendante et n'est pas affilié à AllChinaBuy sauf indication explicite.",
  "footer.mainCta": "Visiter le Site Principal",
  "footer.copyright": "AllChinaBuy Spreadsheet. Tous droits réservés.",
  "breadcrumb.home": "Accueil",
  "article.readMore": "Lire la Suite",
  "article.published": "Publié",
  "article.updated": "Mis à jour",
  "article.author": "Équipe Éditoriale",
  "article.minRead": "min de lecture",
  "seo.title.home": "AllChinaBuy Spreadsheet – Produits, Vendeurs, Contrôle Qualité & Guide d'Expédition",
  "seo.description.home": "Explorez le AllChinaBuy Spreadsheet avec des listes de produits, des vendeurs de confiance, des conseils de contrôle qualité, des informations d'expédition, des guides d'entrepôt, des avis et des ressources d'achat pratiques.",
  "meta.keywords": "AllChinaBuy, AllChinaBuy Spreadsheet, avis AllChinaBuy, expédition AllChinaBuy, coupon AllChinaBuy, code de réduction AllChinaBuy, entrepôt AllChinaBuy, contrôle qualité AllChinaBuy, AllChinaBuy légitime, guide AllChinaBuy",
  "compare.feature": "Fonctionnalité",
  "compare.allchinabuy": "AllChinaBuy",
  "compare.superbuy": "Superbuy",
  "compare.cssbuy": "CSSBuy",
  "compare.sugargoo": "Sugargoo",
  "compare.productDiscovery": "Découverte de produits",
  "compare.spreadsheet": "Ressources tableur",
  "compare.qcProcess": "Processus de contrôle qualité",
  "compare.warehouse": "Entrepôt",
  "compare.shipping": "Expédition",
  "compare.payment": "Paiement",
  "compare.beginnerFriendly": "Convivial pour débutants",
  "compare.support": "Support",
  "compare.research": "Expérience de recherche",
  "learnMore": "En Savoir Plus",
  "readGuide": "Lire le Guide",
  "backToHome": "← Retour à l'Accueil",
  "safetyCenter.title": "Centre de Sécurité",
  "safetyCenter.description": "Informations de sécurité essentielles pour acheter via des marchés internationaux.",
  "disclaimer.title": "Clause de Non-Responsabilité",
  "disclaimer.text": "Ce site est une ressource d'information indépendante. Toutes les informations sont fournies à des fins éducatives uniquement. Nous ne sommes pas affiliés à AllChinaBuy ou à aucune plateforme d'agent d'achat. Effectuez toujours vos propres recherches avant d'effectuer des achats.",
  "productShowcase.title": "Parcourir les Produits en Vedette",
  "productShowcase.description": "Explorez notre sélection organisée dans chaque catégorie. Cliquez sur n'importe quel article pour visiter le magasin principal et finaliser votre achat.",
  "productShowcase.ctaTitle": "Vous voulez en voir plus ?",
  "productShowcase.ctaDesc": "Visitez le magasin complet pour des milliers de produits supplémentaires dans toutes les catégories.",
  "productShowcase.ctaButton": "Visiter le Magasin Complet",
  "productShowcase.buyNow": "Acheter"
};